import cx from 'classnames';
import { COVER_PHOTO_CHANGE, COVER_PHOTO_REMOVE, GROUP_NAME } from 'mk/autogenerated/translations/GroupCoverForm.a55b20e8792b7f33c714b7d8ac0d3501'
import { GroupEntity } from 'mk2/apps/blogs/schemas';
import Loading from 'mk2/components/Loading';
import MenuItem from 'mk2/components/menu/MenuItem';
import { FormPageType } from 'mk2/constants';
import Menu from 'mk2/containers/Menu/Menu';
import PhotosUpload, {
    PhotosUploadConfig,
    PhotoUploadType,
    UploadedPhoto,
} from 'mk2/containers/PhotosUpload/PhotosUpload';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import React from 'react';

import styles from './GroupCoverForm.mscss';

export const GROUP_COVER_MENU_MORE = 'GROUP_COVER_MENU_MORE';

export const GROUP_COVER_UPLOAD_FORM_NAME = 'GROUP_COVER_UPLOAD_FORM';

const photosConfig: PhotosUploadConfig = {
    photoType: 'group_cover',
    multiple: false,
    showPhotoCode: false,
    nameForCoverPreview: GROUP_NAME,
};

export interface GroupCoverFormData {
    photos: UploadedPhoto[];
}

interface OwnProps {
    group: GroupEntity;
    groupLoadingState: LoadingState;
    className?: string;
    groupCover: React.ReactNode;
    photosField: React.ReactNode;
    requestUser: UserEntity;
    permissions: string[];
    isModerator: boolean;

    onToggleMenuMore(e);
    onRemove(groupId: number);
    onOpenFileExplorer();
    onSave(values: GroupCoverFormData, groupId: number);
}

type Props = OwnProps;

class GroupCoverFormComponent extends React.Component<Props & MKReduxFormInjectedProps<GroupCoverFormData, Props>> {

    public render() {
        const {
            className, currentFormPage, group, groupCover, groupLoadingState,
            isModerator, onToggleMenuMore, onOpenFileExplorer,
            permissions, photosField, requestUser,
        } = this.props;

        let role: string = null;
        if (group) {
            if (isModerator) {
                role = 'moderator';
            } else if (permissions.indexOf('forum.can_manage_forum') !== -1) {
                role = 'admin';
            }
        }

        let showGroupCover = 'viewWithoutMenu';
        if (role === 'moderator' || role === 'admin') {
            showGroupCover = 'viewWithMenu';
        }
        if (currentFormPage === FormPageType.ChangeGroupCover) {
            showGroupCover = 'change';
        }

        const groupLoaded = isSuccess(groupLoadingState);
        return (
            <React.Fragment>
                {showGroupCover === 'change' && (
                    <div>
                        <PhotosUpload
                            formName={GROUP_COVER_UPLOAD_FORM_NAME}
                            nameForCoverPreview={group ? group.name : ''}
                            showPhotoCode={false}
                            photoUploadType={PhotoUploadType.COVER_PHOTO}
                        />
                    </div>
                )}
                {showGroupCover === 'viewWithoutMenu' && (
                    groupCover
                )}
                {showGroupCover === 'viewWithMenu' && (
                    <Menu
                        className={cx(styles.GroupCoverForm, className)}
                        menuId={GROUP_COVER_MENU_MORE}
                        trigger={(
                            <div
                                onClick={!group.coverPhoto ? onOpenFileExplorer : onToggleMenuMore}
                            >
                                {groupCover}
                            </div>
                        )}
                        triggerShadow={false}
                        dropdownPositionTop="-100%r + 10"
                        dropdownPositionRight="-10"
                    >
                        { groupLoaded ? [
                            <MenuItem
                                label={COVER_PHOTO_CHANGE}
                                key="changeMenuItem"
                                icon="fa-image"
                                onClick={this.handleChangeCoverPhoto}
                            />,
                            <MenuItem
                                label={COVER_PHOTO_REMOVE}
                                key="removeMenuItem"
                                icon="fa-trash"
                                onClick={this.handleRemoveCoverPhoto}
                            />,
                        ] : (
                            <div className={styles.GroupCover__loadingWrapper}>
                                <Loading
                                    error={false}
                                    pastDelay
                                    isLoading
                                    timedOut={false}
                                />
                            </div>
                        )}
                    </Menu>
                )}
                {(showGroupCover === 'viewWithMenu' || showGroupCover === 'change') && (
                    photosField
                )}
            </React.Fragment>
        );
    }

    private handleChangeCoverPhoto = () => {
        const {onOpenFileExplorer} = this.props;
        onOpenFileExplorer();
    };

    private handleRemoveCoverPhoto = () => {
        const {group, onRemove} = this.props;
        onRemove(group.id);
    };
}

export const GroupCoverForm = mkReduxFormNew<GroupCoverFormData, Props>({
    formName: GROUP_COVER_UPLOAD_FORM_NAME,
    photosConfig,
    onValidate: (values) => ({}),
    onSave: (values, props) => props.onSave(values, props.group.id),
    disableDirtyCheck: true,
})(GroupCoverFormComponent);
